import { render, staticRenderFns } from "./RequestProductDetail.vue?vue&type=template&id=095c2783&scoped=true&"
import script from "./RequestProductDetail.vue?vue&type=script&lang=js&"
export * from "./RequestProductDetail.vue?vue&type=script&lang=js&"
import style0 from "./RequestProductDetail.vue?vue&type=style&index=0&id=095c2783&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095c2783",
  null
  
)

export default component.exports